import Image from '@space-core/components/image'
import { customMedia } from '@space-core/styles'

import styled from 'styled-components'

export const Section = styled.section<{ $theme: string }>`
  margin-top: calc(var(--spacer-12) * -1);
  position: relative;

  &::after {
    content: '';
    width: 100%;
    height: 6.188rem;
    filter: blur(1.375rem);
    background-color: ${({ $theme }) =>
      $theme === 'dark' ? 'var(--hc-color-neutral-900)' : 'var(--hc-color-neutral-100)'};
    position: absolute;
    bottom: -3.75rem;
    left: 0px;
    backdrop-filter: blur(0.188rem);
  }
`

Section.displayName = 'BannerEmptyStateSection'

export const Container = styled.div<{ $showBannerHighlight?: boolean }>`
  height: 28rem;
  background-color: var(--hc-color-neutral-500);
  ${({ $showBannerHighlight }) =>
    `${$showBannerHighlight && 'border: solid 0.188rem var(--blue)'};`}
  ${customMedia.lessThan('md')`
    max-height: 11.375rem;
  `}
`

Container.displayName = 'BannerEmptyStateContainer'

export const ImageLogo = styled(Image)`
  top: var(--spacer-7);
  right: var(--spacer-12);
`

ImageLogo.displayName = 'BannerEmptyStateImageLogo'

export const OptionsModal = styled.div`
  z-index: 10;
  box-shadow: 0 1rem 2.5rem -0.5rem #0000001f;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`
OptionsModal.displayName = 'BannerEmptyStateOptionsModal'

export const Highlight = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 11;
`
Highlight.displayName = 'BannerEmptyStateHighlight'

export const Line = styled.div`
  width: 100%;
  height: 1.25rem;
  background-color: var(--hc-color-neutral-400);
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;

  &:nth-child(1) {
    width: 50%;
  }

  &:nth-child(2) {
    width: 100%;
  }

  &:nth-child(3) {
    width: 30%;
  }
`
Line.displayName = 'BannerEmptyStateLine'
